/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Ember_LabelInputs */

const bn_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অঙ্গার`)
};

const de_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glut`)
};

const el_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χόβολη`)
};

const en_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ember`)
};

const es_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascua`)
};

const fr_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braise`)
};

const hi_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंगार`)
};

const hu_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parázs`)
};

const id_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bara`)
};

const it_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brace`)
};

const ja_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`残り火`)
};

const ko_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타다 남은 것`)
};

const nl_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sintel`)
};

const pl_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedopałek`)
};

const pt_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brasa`)
};

const ru_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эмбер`)
};

const sv_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glödande kol`)
};

const tr_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kor`)
};

const uk_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ембер`)
};

const vi_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`than hồng`)
};

const zh_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`余烬`)
};

const zh_hant_theme_ember_label = /** @type {(inputs: Theme_Ember_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`餘燼`)
};

/**
* | output |
* | --- |
* | "Ember" |
*
* @param {Theme_Ember_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const theme_ember_label = /** @type {((inputs?: Theme_Ember_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Ember_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_theme_ember_label(inputs)
	if (locale === "de") return de_theme_ember_label(inputs)
	if (locale === "el") return el_theme_ember_label(inputs)
	if (locale === "en") return en_theme_ember_label(inputs)
	if (locale === "es") return es_theme_ember_label(inputs)
	if (locale === "fr") return fr_theme_ember_label(inputs)
	if (locale === "hi") return hi_theme_ember_label(inputs)
	if (locale === "hu") return hu_theme_ember_label(inputs)
	if (locale === "id") return id_theme_ember_label(inputs)
	if (locale === "it") return it_theme_ember_label(inputs)
	if (locale === "ja") return ja_theme_ember_label(inputs)
	if (locale === "ko") return ko_theme_ember_label(inputs)
	if (locale === "nl") return nl_theme_ember_label(inputs)
	if (locale === "pl") return pl_theme_ember_label(inputs)
	if (locale === "pt") return pt_theme_ember_label(inputs)
	if (locale === "ru") return ru_theme_ember_label(inputs)
	if (locale === "sv") return sv_theme_ember_label(inputs)
	if (locale === "tr") return tr_theme_ember_label(inputs)
	if (locale === "uk") return uk_theme_ember_label(inputs)
	if (locale === "vi") return vi_theme_ember_label(inputs)
	if (locale === "zh") return zh_theme_ember_label(inputs)
	return zh_hant_theme_ember_label(inputs)
});